import React, {Component} from "react";

import {View, Text, TouchableOpacity, Image} from 'react-native'

import {estilos} from '../util/estilos'

import Bloco from '../componentes/Bloco'


export default class  ItemCard extends Component {


	constructor(props) {
        
        super(props);
    }

    render() {
 
        return(
			<Bloco todaArea={true}>
				<TouchableOpacity onPress={()=>this.props.acao()}>
					<View style={{marginTop:5}}/>
					<View style={{justifyContent: 'center', alignItems:'center'}}>
						<Image source={require("../imgs/"+this.props.icon)} style={{width:40, height: 40}}/>
						<View style={{marginTop:5}}/>
						<Text style={estilos.rotulo_padrao}>{this.props.titulo}</Text>	 
					</View>
					<View style={{marginTop:5}}/>
				</TouchableOpacity>	
			</Bloco>)    
   }
}